<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1555_246)">
      <path
        d="M31.3392 25.8495L24.4776 21.8499C24.138 21.6532 23.7429 21.5744 23.3538 21.6259C22.9647 21.6773 22.6036 21.8561 22.3267 22.1343L18.9671 25.494C18.8327 25.6298 18.6581 25.7188 18.4692 25.7476C18.2802 25.7764 18.0871 25.7436 17.9183 25.6539L16.7451 25.014C12.6019 22.787 9.20275 19.394 6.96822 15.2549L6.34606 14.0817C6.25643 13.9129 6.22359 13.7198 6.25241 13.5308C6.28122 13.3419 6.37017 13.1673 6.50604 13.0329L9.86572 9.67325C10.1439 9.39642 10.3227 9.03531 10.3741 8.64623C10.4256 8.25715 10.3468 7.86198 10.1501 7.52235L6.15052 0.660788C6.04745 0.48432 5.90518 0.33391 5.73472 0.221179C5.56426 0.108448 5.37017 0.0364144 5.16743 0.0106431C4.9647 -0.0151282 4.75875 0.0060528 4.56551 0.0725497C4.37226 0.139047 4.19689 0.24908 4.05294 0.394147L1.04879 3.3983C0.716078 3.72904 0.452114 4.12236 0.272112 4.55558C0.0921097 4.98881 -0.000370621 5.45337 1.11624e-06 5.9225V7.1135C0.00255366 10.0532 0.729065 12.947 2.11535 15.5394L2.55976 16.3393C5.53137 21.8663 10.0626 26.3975 15.5896 29.3691L16.3895 29.8135C18.9966 31.2359 21.9167 31.9873 24.8865 32H26.1486C26.6177 32.0004 27.0823 31.9079 27.5155 31.7279C27.9487 31.5479 28.3421 31.2839 28.6728 30.9512L31.677 27.9471C31.8191 27.7982 31.9248 27.6185 31.9859 27.422C32.0469 27.2255 32.0617 27.0176 32.029 26.8144C31.9963 26.6112 31.917 26.4184 31.7973 26.251C31.6776 26.0836 31.5208 25.9462 31.3392 25.8495Z"
        fill="#FDFFFD"
      />
    </g>
    <defs>
      <clipPath id="clip0_1555_246">
        <rect :width="width" :height="height" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 32,
    },
    height: {
      type: Number,
      default: 32,
    },
  },
};
</script>

<style lang="scss" scoped></style>
